import React from 'react';

import { TextField, Validations } from '../../../../components/forms';
import Button from 'material-ui/Button';

import {Add, Delete} from 'material-ui-icons';

import Grid from 'material-ui/Grid';

import { TwitterPicker } from 'react-color';

import tsl from '../../../tsl';

export default class EditationAircraftInstances extends React.Component {

	state = {
    };

	componentDidMount = () => {
	}

    propagateChange = (aircrafts) => {
        this.props.onChange(aircrafts);
    }

    handleChange = (index) => (e) => {
        let newAircrafts = this.props.aircrafts;

        newAircrafts[index][e.target.name] = e.target.value;

        this.propagateChange(newAircrafts);
    }

    handleChangeColor = (index) => (color) => {
        let newAircrafts = this.props.aircrafts;

        newAircrafts[index]['calendar'] = {color_hex: color.hex};

        this.propagateChange(newAircrafts);    
    }

    remove = (index) => () => {
        let newAircrafts = [];

        for (let i in this.props.aircrafts) {
            if (i != index) {
                newAircrafts.push(this.props.aircrafts[i]);
            }
        }
        //delete newAircrafts[index];   // not working, keeping NULL as item in array

        this.propagateChange(newAircrafts);
    }

    addNew = () => {
        let newAircrafts = this.props.aircrafts;
        
        newAircrafts.push({
            'reg_no': '',
            calendar: {
                'color_hex': '#00C2D4'
            }
        });

        this.propagateChange(newAircrafts);
    }

	render() {
        return (
            <Grid container spacing={24} className="w-100">
                {this.props.aircrafts.map((aircraft, index) => {
                    return (
                        <Grid item sm={4} xs={12} key={index}>
                            <TextField
                                formActions={this.props.formActions}
                                required
                                fullWidth
                                name="reg_no"
                                value={aircraft.reg_no || ''}
                                onChange={this.handleChange(index)}
                                label={tsl('aircrafts.edit.registration_number')}
                                margin="normal"
                                className="mt-1"
                            />
                            <div style={{backgroundColor: aircraft.calendar.color_hex, height: 20, border: '1px solid #DDD'}}>&nbsp;</div>
                            <br />
                            <TwitterPicker
                                color={aircraft.calendar.color_hex}
                                onChange={this.handleChangeColor(index)}
                                style={{margin: '0 auto'}} className="w-100"
                            />
                            <Button onClick={this.remove(index)} className="w-100" style={{color: "red"}}>
                                <Delete />
                            </Button>
                        </Grid>
                    );
                })}

                <div className="w-100" style={{textAlign: 'right'}}>
                    <br />
                    <Button fab raised color="accent" className="text-white jr-btn-fab-sm"
                        aria-label="add"
                        onClick={this.addNew}
                    >
                        <Add />
                    </Button>
                </div>
            </Grid>
        );
    }

}


// WEBPACK FOOTER //
// ./app/used/aircrafts/routes/EditationAircraftInstances.js